var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:flex-auto mdmax:w-full"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Partner")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _c('p', {
    staticClass: "text-neutral-500 mdmax:break-all"
  }, [_vm._v(_vm._s(_vm.detail.id))])]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.detail.name))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No. Handphone")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.detail.phone_number))])])]), _c('div', {
    staticClass: "mb-6 flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Alamat Email")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.detail.email))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Jumlah Armada")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.detail.total_vehicle))])])]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Alamat")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.detail.address))])])]), _c('div', {
    staticClass: "flex-1"
  }, [_c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("No. Rekening")]), _c('div', {
    staticClass: "flex gap-6"
  }, [_c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Bank")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.bankData.name))])]), _c('div', {
    staticClass: "w-44 mdmax:flex-1 mdmax:w-auto"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("No. Rekening")]), _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.bankData.account))])])])]), _c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Dokumen")]), _c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 block"
  }, [_vm._v("KTP")]), _c('div', {
    staticClass: "border p-2 w-40 rounded-md inline-block"
  }, [_c('a', {
    attrs: {
      "href": _vm.detail.idcard_file_url,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.detail.idcard_file_url,
      "alt": "KTP"
    }
  })])])])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end mdmax:justify-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Hapus",
      "type": "delete",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteModal();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Edit",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.edit();
      }
    }
  })], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleDeleteModal,
      "id": "delete-modal"
    },
    on: {
      "close": _vm.toggleDeleteModal
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "text-cente mt-6 mb-4"
  }, [_vm._v("Apakah Anda yakin akan menghapus partner ini?")]), _c('div', {
    staticClass: "flex justify-center items-center gap-4"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.deletePartnerEntry();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteModal();
      }
    }
  })], 1)])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }